import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
// Giả sử bạn dùng React Router, hãy import Link
// import { Link } from 'react-router-dom';

// --- THEME ---
// Chúng ta sẽ giữ lại theme, nhưng sẽ không dùng các thuộc tính gây lỗi
const theme = {
  colors: {
    background: '#f8f9fa',
    surface: '#ffffff',
    primary: '#20c997',
    text: '#495057',
    heading: '#212529',
    subtleText: '#868e96',
    // 'border' sẽ được gán trực tiếp
  },
  fonts: {
    body: "'Inter', sans-serif",
  },
  fontSizes: {
    base: '1rem',
    h1: '2.75rem',
    h2: '1.5rem',
    h3: '1.2rem',
  },
  spacing: {
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '40px',
    xxl: '64px',
  },
  shadows: {
    main: '0 8px 20px rgba(0, 0, 0, 0.06)',
    // 'hover' sẽ được gán trực tiếp
  },
  borderRadius: '16px',
  breakpoints: {
    tablet: '768px',
    mobile: '500px',
  },
};

type AppTheme = typeof theme;

declare module 'styled-components' {
  export interface DefaultTheme extends AppTheme {}
}

// --- STYLED COMPONENTS ---
const PageContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${({ theme }) => theme.spacing.xl} 15px;
  font-family: ${({ theme }) => theme.fonts.body};
  min-height: 100vh;
`;

const HubContainer = styled.main`
  max-width: 960px;
  margin: 0 auto;
`;

const PageHeader = styled.header`
  text-align: center;
  margin-bottom: ${({ theme }) => theme.spacing.xxl};
`;

const Title = styled.h1`
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.heading};
  font-size: ${({ theme }) => theme.fontSizes.h1};
  font-weight: 800;
  letter-spacing: -1px;
`;

const Subtitle = styled.p`
  color: ${({ theme }) => theme.colors.subtleText};
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
`;

const PolicyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: ${({ theme }) => theme.spacing.lg};
`;

// =============================================================
// === THAY ĐỔI DUY NHẤT NẰM Ở COMPONENT NÀY ===
// =============================================================
const PolicyCard = styled.a`
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.xl};
  box-shadow: ${({ theme }) => theme.shadows.main};
  
  /* SỬA LỖI 1: Gán thẳng mã màu, không đọc từ theme */
  border: 1px solid #dee2e6;
  
  text-decoration: none;
  color: inherit;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-6px);
    /* SỬA LỖI 2: Gán thẳng giá trị box-shadow, không đọc từ theme */
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
  }
`;
// =============================================================

const CardIcon = styled.div`
  font-size: 2.5rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

const CardTitle = styled.h3`
  font-size: ${({ theme }) => theme.fontSizes.h3};
  color: ${({ theme }) => theme.colors.heading};
  font-weight: 700;
  margin: 0 0 ${({ theme }) => theme.spacing.sm} 0;
`;

const CardDescription = styled.p`
  font-size: 0.95rem;
  color: ${({ theme }) => theme.colors.subtleText};
  line-height: 1.7;
  margin: 0;
`;

const policies = [
  {
    icon: '⚖️',
    title: 'Điều khoản và Điều kiện',
    description: 'Các quy định và điều kiện pháp lý khi sử dụng dịch vụ và trang web của chúng tôi.',
    path: '/terms-conditions',
  },
  {
    icon: '🛡️',
    title: 'Chính sách Bảo mật',
    description: 'Cam kết của chúng tôi về việc thu thập, sử dụng và bảo vệ thông tin cá nhân của bạn.',
    path: '/privacy-policy',
  },
  {
    icon: '🔄',
    title: 'Bảo hành & Đổi trả',
    description: 'Quy định chi tiết về việc bảo hành sản phẩm và các trường hợp hỗ trợ đổi trả hàng.',
    path: '/warranty-return-policy',
  },
  {
    icon: '💳',
    title: 'Chính sách Thanh toán',
    description: 'Thông tin về các phương thức thanh toán được chấp nhận và hướng dẫn giao dịch an toàn.',
    path: '/payment-policy',
  },
  {
    icon: '🚚',
    title: 'Chính sách Giao hàng',
    description: 'Quy định về phạm vi, chi phí và thời gian vận chuyển đơn hàng đến tay khách hàng.',
    path: '/shipping-policy',
  },
];


// --- COMPONENT CHÍNH ---
const ChinhSach: React.FC = () => {
  return (
    <>
    <title>Tổng hợp Chính sách và Điều khoản</title>

    <ThemeProvider theme={theme}>
      <PageContainer>
        <HubContainer>
          <PageHeader>
            <Title>Tổng hợp Chính sách và Điều khoản</Title>
          </PageHeader>

          <PolicyGrid>
            {policies.map((policy) => (
              <PolicyCard key={policy.title} href={policy.path}>
                <CardIcon>{policy.icon}</CardIcon>
                <CardTitle>{policy.title}</CardTitle>
                <CardDescription>{policy.description}</CardDescription>
              </PolicyCard>
            ))}
          </PolicyGrid>

        </HubContainer>
      </PageContainer>
    </ThemeProvider>
    </>
    
  );
};

export default ChinhSach;